export {
  default,
  default as useSharedResourceHistory,
} from "./useSharedResourceHistory";
